import React from 'react';

import { DestinationLinksProvider, FooterLinksProvider, SiteLinksProvider } from '@hooks/index';
import { GenericService, GraphqlService, MailchimpService, PersonalService } from '@services/index';
import { FB_APP_ID, FORGOT_PASSWORD_PAGE_ID, PageProps, REVALIDATION_TIME } from '@constants/index';

import { Meta } from '@components/layout/Meta/Meta';
import CookieDialog from '@components/forms/CookieDialog/CookieDialog';
import Layout from '@components/layout/Layout/Layout';
import i18NextInitializer from '@helpers/i18NextInitializer';
import {
  ForgotPasswordModule,
  IForgotPasswordPagePublicationFields,
} from 'modules/ForgotPasswordModule';
import ForgotPasswordPage from '@components/pages/ForgotPasswordPage/ForgotPasswordPage';
import { GetStaticPropsContext } from 'next';

const { FacebookProvider } = require('react-facebook');

interface Props extends PageProps<IForgotPasswordPagePublicationFields> {}

const FaqPage = ({ fields, destinationLinks, siteLinks, footerLinks }: Props) => {
  return (
    <FacebookProvider appId={FB_APP_ID} xfbml>
      <FooterLinksProvider value={footerLinks}>
        <DestinationLinksProvider value={destinationLinks}>
          <SiteLinksProvider value={siteLinks}>
            <Layout paddings>
              <Meta
                title={fields?.meta_title || fields?.title}
                description={fields?.meta_description || ''}
              />
              <ForgotPasswordPage fields={fields} />
            </Layout>
            <CookieDialog />
          </SiteLinksProvider>
        </DestinationLinksProvider>
      </FooterLinksProvider>
    </FacebookProvider>
  );
};

export default FaqPage;

export const getStaticProps = async ({ locale, preview }: GetStaticPropsContext) => {
  i18NextInitializer(String(locale));
  GraphqlService.setLocale(locale);
  PersonalService.setLocale(locale);
  GenericService.setLocale(locale);
  MailchimpService.setLocale(locale);

  GraphqlService.setPreview(!!preview);

  const page = await ForgotPasswordModule.getSinglePage(FORGOT_PASSWORD_PAGE_ID);

  if (!page || !page.fields) {
    return {
      notFound: true,
      revalidate: REVALIDATION_TIME,
    };
  }

  return {
    props: page,
    revalidate: REVALIDATION_TIME,
  };
};
